<template>
  <div :class="$style.banner">
    <div :class="$style.map">
      <img src="/images/banner.png" alt="" />
    </div>
    <div :class="$style.image">
      <img src="/images/afisha.png" alt="" />
    </div>
  </div>
</template>
<style lang="scss" module>
.banner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin: 0 0 2rem 0;
  padding: 0 1rem;
  @include custom(1100) {
    grid-template-columns: 1fr;
  }
  .map {
    @include custom(1100) {
      display: flex;
      justify-content: center;
      img {
        width: 50rem;
      }
    }
    @include custom(575) {
      display: none;
    }
    img {
      border-radius: 1.5rem;
      width: 40rem;
      height: 100%;
      @include custom(1210) {
        width: 35rem;
      }
    }
  }
  .image {
    border-radius: 1.5rem;
    max-height: 37rem;
    overflow: auto;
    @include scrollbarYRed;
    padding-right: 0.25rem;
    @include custom(1100) {
      max-height: 20rem;
    }

    img {
      border-radius: 1.5rem;
      width: 100%;
    }
  }
}
</style>
